<template>
  <div class="pay-detail">
    <NavTop title="提交订单" />
    <div class="goods-con">
      <p class="title">核对订单信息</p>
      <p class="label">
        <span style="width: 50%">商品</span>
        <span style="width: 20%">单价(元)</span>
        <span style="width: 15%">数量</span>
        <span style="width: 15%">总价(元)</span>
      </p>
      <p class="normal">{{ form.des }}</p>
      <p class="detail">
        <span style="width: 50%" class="left">商品种类：角色</span>
        <span style="width: 20%">￥{{ form.amount }}</span>
        <span style="width: 15%">1</span>
        <span style="width: 15%">￥{{ form.amount }}</span>
      </p>
      <p class="normal">游戏区服：{{ form.gameServer }}</p>
    </div>
    <van-form @submit="onSubmit">
      <div class="goods-con form-sub">
        <p class="title">填写联系方式</p>
        <van-field
          v-model="form.contact"
          name="contact"
          label="联系电话"
          placeholder="请输入联系电话"
          :rules="[{ required: true, message: '联系电话不能为空' }]"
        />
        <van-field
          v-model="form.qq"
          name="qq"
          label="QQ号码"
          placeholder="请输入QQ号码"
          :rules="[{ required: true, message: 'QQ号码不能为空' }]"
        />
        <van-field
          v-model="form.remarks"
          name="remarks"
          type="textarea"
          label="备注信息"
          placeholder="请输入备注信息"
        />
      </div>
      <p class="real-amount">
        应付金额：￥<span style="color: #f74b3d">{{ form.amount }}</span
        >元
      </p>
      <van-row class="login-auto">
        <van-checkbox icon-size="14px" shape="square" v-model="autoLogin"
          >我同意<router-link
            style="color: #35abd8"
            :to="{ path: '/help-detail', query: { name: 'buy-agree' } }"
            >《账号购买协议》</router-link
          ></van-checkbox
        >
      </van-row>
      <div class="button-con">
        <van-button size="small" round block type="info" native-type="submit"
          >提交订单</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import NavTop from "@/components/nav-top/index.vue";
import { getByGoodsId } from "@/api/person";
import { createOrder } from "@/api/home";
export default {
  name: "PayDetail",
  components: { NavTop },
  data() {
    return {
      autoLogin: "",
      form: {},
    };
  },
  mounted() {
    if (this.$route.query.goodsId) {
      this.getByGoodsId();
    }
  },
  methods: {
    onSubmit() {
      if (this.autoLogin) {
        createOrder(this.objToForm(this.form)).then((res) => {
          this.$router.push({
            path: "order-detail",
            query: { orderId: res.orderId },
          });
        });
      } else {
        this.$toast.fail("请勾选账号交易购买协议");
      }
    },
    getByGoodsId() {
      getByGoodsId(this.objToStr({ goodsId: this.$route.query.goodsId })).then(
        (res) => {
          this.form = res;
        }
      );
    },
  },
};
</script>
<style scoped>
.login-auto {
  font-size: 12px;
  float: right;
  padding: 10px;
}
.pay-detail .top {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  background: #ebebeb;
  position: relative;
  text-align: center;
}
.pay-detail .top .back {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 24px;
}
.pay-detail .goods-con {
  border: 1px solid #d7d7d7;
  margin: 8px;
  font-size: 12px;
}
.pay-detail .goods-con .title {
  background: #f5f5f5;
  line-height: 28px;
  text-indent: 10px;
}
.pay-detail .goods-con .label {
  border-bottom: 1px solid #d7d7d7;
  margin: 0;
  line-height: 30px;
}
.pay-detail .goods-con .label span {
  display: inline-block;
  text-align: center;
}
.pay-detail .goods-con .detail {
  margin: 12px 0;
}
.pay-detail .goods-con .detail span {
  display: inline-block;
  text-align: center;
}
.pay-detail .goods-con .detail .left {
  text-align: left;
  text-indent: 10px;
}
.pay-detail .goods-con .normal {
  text-indent: 10px;
  margin: 12px 0;
}
.pay-detail .button-con {
  padding: 0 10px 0 200px;
}
.pay-detail .real-amount {
  text-align: right;
  padding-right: 20px;
  margin: 0;
  font-size: 14px;
}
</style>